import { RootState } from '@state/types';

export const getIcsData = ({ ics }: RootState) => ics.parsedIcsData;

export const getIcsUpdatesDialogData = ({ ics }: RootState) => ics.icsUpdatesDialog;

export const getIcsUpdatesTimestamp = ({ ics }: RootState) => ics.icsUpdatesDialog.timestamp;
export const getPreviousIcsUpdatesTimestamp = ({ ics }: RootState) => ics.icsUpdatesDialog.timestamp;
